export default "__VITE_ASSET__DXlg0ZwP__"